import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MessengerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"messenger"}/>
}
